import { Injectable }               from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot,
	RouterStateSnapshot }           from '@angular/router';

import { Observable }               from 'rxjs/Observable';


/**
 * Only logged-in users can access this system.  This looks for the
 * session object and returns false if it cannot find it.
 *
 */
@Injectable()
export class OnlyLoggedInGuard implements CanActivate {
	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

		// If there is a valid current user in session, then allow navigation.
		let userString: string = sessionStorage.getItem('currentUser');
		return null !== userString;

	}

}



// WEBPACK FOOTER //
// ./src/app/services/miscellaneous/only-logged-in.guard.ts